import api from '@/api'

export default {
  sendAppointmentEmail(fields) {
    return api.post('/mailers/rendez-vous', fields)
  }
}
